export default {"src":"/_next/static/media/doorswindows.7be972c0.svg","height":33,"width":37,"blurWidth":0,"blurHeight":0};